(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeTagTypeConfigService', [
			'$http',
			'$q',
			'pxUriPathService',
			ContentTypeTagTypeConfigService
		]);

	/**
	 * @typedef {Object} TagTypeAssoication
	 * @param {Number} TagTypeId The id of the tag type being associated with an item
	 */

	/**
	* @ngdoc service
	* @name smb-app.smbContentTypeTagTypeConfigService
	*
	* @description
	* Exposes methods for adding and removing index types from a library
	*/
	function ContentTypeTagTypeConfigService($http, $q, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeTagTypeConfigService#getTagTypes
			 * @methodOf smb-app.smbContentTypeTagTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Gets all tag types that are associated with a content type.
			 * 
			 * @param {String|Number} id The content type id
			 * 
			 * @returns {Promise<TagType[]>} A promise that resolves to a collection of @see TagType objects.
			 */
			getTagTypes: getTagTypes,

			/**
			 * @ngdoc method
			 * @name smbContentTypeTagTypeConfigService#setTagTypes
			 * @methodOf smb-app.smbContentTypeTagTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Sets the tag type associations for a single content type. This function will
			 * completely replace the current set of associations on the content type with
			 * this new set.
			 * 
			 * @param {String|Number} id The content type id
			 * @param {TagTypeAssoication[]} associations The collection of tag type associations to
			 * put on the content type. 
			 */
			setTagTypes: setTagTypes
		};

		function getTagTypes(id) {
			if (!(typeof id === 'string' || typeof id === 'number')) {
				return $q.reject(new Error('Missing required document type id'));
			}

			var uri = pxUriPathService.resolvePath('/f/' + id + '/tagtypes');
			return $http.get(uri)
				.then(function(res) {
					return res.data;
				});
		}

		function setTagTypes(id, associations) {
			if (!(typeof id === 'string' || typeof id === 'number')) {
				return $q.reject(new Error('Missing required document type id'));
			} else if (!associations) {
				return $q.reject(new Error('Must specify the associations to add to the document type.'));
			}

			var uri = pxUriPathService.resolvePath('/f/' + id + '/tagtypes');
			return $http.put(uri, associations)
				.then(function() {
					return associations;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentConfigServices/contentTypeTagTypeConfigService.js
// module id = 138
// module chunks = 1